import React from 'react';
import { useDocument } from 'react-firebase-hooks/firestore';
import { Divider } from 'antd';
import Client from 'containers/app/client';
import { useIsProfileComplete } from 'hooks/profile';
import { useUserWithRole } from 'hooks/custom-auth';
import stages from 'containers/worker/stages';
import DBSCheck from 'containers/worker/dbs-check';
import ShiftsInfo from 'containers/worker/shifts-info';
import { LayoutPage, LayoutGrid } from 'components/layouts';
import LoadingFullPage from 'components/loading-full-page';
import UserStories from 'components/user-stories';
import ProfileStepsWidget from './profile-steps-widget';
import BookingsPedingWidget from './bookings-peding-widget';
import BookingsWidget from './bookings-widget';

import './style.css';
import RatingAverage from 'components/rating-average';

const dbsCheck = [DBSCheck];
const shiftsInfo = [ShiftsInfo];

const Dashboard = () => {
  const [values, loading, error] = useDocument(Client.dbProfile());
  const [dbs, dbsLoading] = useIsProfileComplete(dbsCheck);
  const [shifts, shiftsLoading] = useIsProfileComplete(shiftsInfo);
  const [profile, profileLoading] = useIsProfileComplete(stages);
  const [user, loadingUser, errorUser] = useUserWithRole(Client.auth);

  if (loading || dbsLoading || profileLoading || shiftsLoading || loadingUser)
    return (
      <LayoutPage className="dashboard-page">
        <LayoutPage.Container className="wrapper">
          <LoadingFullPage />
        </LayoutPage.Container>
      </LayoutPage>
    );

  if (error) throw error;
  if (errorUser) throw errorUser;

  const { isRegisteredInDBS } = values.data();
  const { registered } = isRegisteredInDBS || { registered: false };

  const profilePercentage = Math.round((profile / stages.length) * 100);
  const dbsPercentage = Math.round((dbs / dbsCheck.length) * 100);
  const shiftsPercentage = Math.round((shifts / shiftsInfo.length) * 100);

  const isRegistrationFinish =
    profilePercentage === 100 &&
    dbsPercentage === 100 &&
    shiftsPercentage === 100;

  return (
    <LayoutPage className="dashboard-page">
      <LayoutPage.Container className="wrapper">
        <h1>Dashboard</h1>
        {isRegistrationFinish ? (
          <>
            <LayoutGrid>
              <BookingsPedingWidget />
              <RatingAverage role="isWorker" userId={user.claims.user_id} />
            </LayoutGrid>
            <Divider />
            <BookingsWidget />
          </>
        ) : null}
        <ProfileStepsWidget
          isRegistered={registered}
          profilePercentage={profilePercentage}
          dbsPercentage={dbsPercentage}
          shiftsPercentage={shiftsPercentage}
        />
        <UserStories />
      </LayoutPage.Container>
    </LayoutPage>
  );
};

export default Dashboard;
